var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.25C3.77688 0.25 2.375 1.65188 2.375 3.375V5.25H1.75C1.41848 5.25 1.10054 5.38169 0.866119 5.61613C0.631694 5.85056 0.5 6.1685 0.5 6.5V11.5C0.5 11.8315 0.631694 12.1494 0.866119 12.3839C1.10054 12.6183 1.41848 12.75 1.75 12.75H9.25C9.5815 12.75 9.89944 12.6183 10.1339 12.3839C10.3683 12.1494 10.5 11.8315 10.5 11.5V6.5C10.5 6.1685 10.3683 5.85056 10.1339 5.61613C9.89944 5.38169 9.5815 5.25 9.25 5.25H8.625V3.375C8.625 1.65188 7.22312 0.25 5.5 0.25ZM3.625 3.375C3.625 2.34125 4.46625 1.5 5.5 1.5C6.53375 1.5 7.375 2.34125 7.375 3.375V5.25H3.625V3.375ZM6.125 10.0769V11.5H4.875V10.0769C4.6565 9.95175 4.48106 9.76331 4.37175 9.5365C4.2625 9.30963 4.22455 9.05494 4.26294 8.80613C4.30131 8.55725 4.41419 8.32588 4.58675 8.14244C4.75925 7.95906 4.98331 7.83225 5.22938 7.77875C5.41213 7.73831 5.60162 7.7395 5.78387 7.78206C5.96619 7.82463 6.13656 7.90756 6.2825 8.02481C6.42844 8.142 6.54619 8.29044 6.62712 8.45925C6.708 8.62806 6.75 8.81281 6.75 9C6.74963 9.21856 6.69169 9.43325 6.58194 9.62225C6.47225 9.81131 6.31462 9.96813 6.125 10.0769Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.dee29c99493e6804ece1429ffca3713c.svg";
export { ForwardRef as ReactComponent };